import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ROLES, USER_TYPES } from 'src/app/constant/constant';
import { UserRoleAuthorizeGuard } from 'src/app/guards/user-role-authorize.guard';
import { AuthEgdGuard } from '../../../guards/auth-egd.guard';
import { MedicalProfessionDashboardComponent } from '../shared/medical-profession-dashboard/medical-profession-dashboard.component';
import { FetchUsersComponent } from './fetch-users/fetch-users.component';
import { ViewUserDetailsComponent } from './view-user-details/view-user-details.component';
import { UploadDocumentsVendorComponent } from './upload-documents-vendor/upload-documents-vendor.component';

const userTypes = USER_TYPES;

const routes: Routes = [
  {
    path: `:slug/${userTypes['VENDOR']}`,
    component: MedicalProfessionDashboardComponent,
    canActivate: [UserRoleAuthorizeGuard],
    canActivateChild: [UserRoleAuthorizeGuard, AuthEgdGuard],
    data: { role_type: 'vendor', sub_role: [ROLES['Vendor']] },
    children: [
      {
        path: 'dashboard',
        canActivate: [UserRoleAuthorizeGuard],
        component: FetchUsersComponent,
        data: { role_type: 'vendor', sub_role: [ROLES['Vendor']] }
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'fetch-users',
        canActivate: [UserRoleAuthorizeGuard],
        component: FetchUsersComponent,
        data: { role_type: 'vendor', sub_role: [ROLES['Vendor']] }
      },
      {
        path: 'view-details/:req_id',
        canActivate: [UserRoleAuthorizeGuard],
        component: ViewUserDetailsComponent,
        data: { role_type: 'vendor', sub_role: [ROLES['Vendor']] }
      },
      {
        path: 'upload-documents/:patient_guid/:consultation_id/:isSupport',
        canActivate: [UserRoleAuthorizeGuard],
        component: UploadDocumentsVendorComponent,
        data: { role_type: 'vendor', sub_role: [ROLES['Vendor']] }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VendorRoutingModule {}
